import React , { Component } from 'react';
import { injectIntl } from 'react-intl';

import * as ActionConstants from '../../constants/';

import Drilldown from './Drilldown';

import TetherComponemt from 'react-tether';

import Helpable from '../Helpable';


class Toolbar extends Component {

  constructor(props) {
    super(props);

    this.toolbarShowInfoHandler = this.toolbarShowInfoHandler.bind(this);

    this.state = {
      showInfo: false
    }
  }

  toolbarShowInfoHandler(data) {

    if (data.hasDescription) {
      this.setState({
        showInfo: data.show
      });
    }
  }

  showDataHandler() {
    if (this.props.toggleDetailsInfo.dataDetails && this.props.hasData)
      this.props.toggleDetailsInfo.handler();
  }

  render() {
    const {formatMessage} = this.props.intl;

    let selectList = [];
    let selectItem = null;

    let dataDetails = this.props.toggleDetailsInfo.dataDetails;
    let hasDescription = this.props.toggleDetailsInfo.hasDescription;

    let descriptionClass = "btn btn-link " + (!hasDescription?"disabled":"");


    let exportCSVLabel = formatMessage({id:"panel.action.export.csv"});
    let exportPNGLabel = formatMessage({id:"panel.action.export.png"});




    // Se metto in || la variabile dataDetails con true, non si riesce a distinguere il caso in cui la costante è null o false.
    dataDetails = (dataDetails==null?true:dataDetails);


    let dataIconClass = "fa "+(this.props.toggleDetailsInfo.show? "fa-bar-chart": "fa-table");

    let dataButtonClass  = "btn btn-link " + (this.props.toggleDetailsInfo.dataDetails && this.props.hasData?"":"disabled");



    let csvExportStyle = {
      cursor:(dataDetails?'pointer':'not-allowed')
    };


    let csvItem = null;

    if (dataDetails && this.props.hasData) {
        csvItem = <li><a style={csvExportStyle} onClick={this.props.exportHandler.bind(this, {action:'panel.action.export.csv'})}>{exportCSVLabel}</a></li>;
    } else {
      csvItem = <li className="disabled"><a style={csvExportStyle}>{exportCSVLabel}</a> </li>;
    }


    let pngItems = null;

    if (this.props.hasData) {
      pngItems =
      <li key={0} className="dropdown-submenu pull-left">
        <a  style={{cursor:'pointer'}} onClick={this.props.exportHandler.bind(this, {action:'panel.action.export.png', sizeOption:ActionConstants.IMAGE_M})}>{exportPNGLabel}</a>
        <ul className="dropdown-menu" role="menu">
          <li key={0}><a style={{cursor:'pointer'}} onClick={this.props.exportHandler.bind(this, {action:'panel.action.export.png', sizeOption:ActionConstants.IMAGE_S})}>{formatMessage({id:ActionConstants.IMAGE_S})}</a></li>
          <li key={1}><a style={{cursor:'pointer'}} onClick={this.props.exportHandler.bind(this, {action:'panel.action.export.png', sizeOption:ActionConstants.IMAGE_M})}>{formatMessage({id:ActionConstants.IMAGE_M})}</a></li>
          <li key={2}><a style={{cursor:'pointer'}} onClick={this.props.exportHandler.bind(this, {action:'panel.action.export.png', sizeOption:ActionConstants.IMAGE_L})}>{formatMessage({id:ActionConstants.IMAGE_L})}</a></li>
        </ul>
      </li>
    } else {
      pngItems=
      <li key={0} className="dropdown-submenu pull-left disabled">
        <a className="disabled">{exportPNGLabel}</a>
      </li>

    }







    if (this.props.filtersList) {

      this.props.filtersList.forEach(function(option,i) {
        let optionName = option.label;

        let options = [];
        option.values.forEach(function(value,i) {
          options.push(<option key={value.key} value={value.value}>{value.item}</option>)
        });

        if (options.length >0) {
          let selectedValue = optionName + "."+ this.props.location.query[optionName];

          selectItem = (
            <li key={i}>
              <select id={option.label} className="form-control" onChange={option.onChange} value={selectedValue}>
                {options}
              </select>
            </li>
          );

            selectList.push(selectItem);
          }
        }.bind(this))
      }

    let infoInformation = <div><h3>{this.props.description.title}</h3> {this.props.description.description} </div>;

    return (

      <div className="row toolbar-pf">

      <div className="col-sm-12">
        <div className="toolbar-pf-actions">

          <div id="infoButton" style={{paddingLeft:'5px'}} className="form-group">

            <TetherComponemt attachment="middle left"
              targetAttachment="middle right"
              renderElementTo="#infoButton"
              style={{
                paddingBottom:'10px',
                paddingLeft:'10px',
                paddingRight:'10px',
                width:'60%',
                opacity: '0.9',
                background: '#6d6c6c',
                color: '#fff',
                zIndex:1350
              }}>
              <button id="infoButton" ref="info" style={{outline:'none'}} className={descriptionClass}
                      onMouseOver={this.toolbarShowInfoHandler.bind(this, {hasDescription:hasDescription, show:true})}
                      onMouseLeave={this.toolbarShowInfoHandler.bind(this, {hasDescription:hasDescription,show:false})}>
                      <i className="fa fa-info fa-fw"></i>
              </button>
              {this.state.showInfo && infoInformation}

            </TetherComponemt>

          </div>

        <Drilldown {...this.props}/>

          <div className="toolbar-pf-action-right">

            <Helpable bind="export" attachment="top right" guideRef="toolbar.export.guide">

              <div id="export" className="form-group toolbar-pf-view-selector">

                <div className="dropdown btn-group">
                  <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    {formatMessage({id:"panel.action.export"})}
                    <span className="caret"></span>
                  </button>
                    <ul  className="dropdown-menu dropdown-menu-right">
                      {pngItems}
                      {csvItem}
                    </ul>
                  </div>
                </div>
              </Helpable>

          <div className="form-group">
            <Helpable bind="dataButton" attachment="top right" guideRef="toolbar.dataicon.guide">
              <button id="dataButton" style={{outline:'none'}} className={dataButtonClass} onClick={this.showDataHandler.bind(this)}><i className={dataIconClass}></i></button>
            </Helpable>
            </div>
          </div>

        </div>


        {(this.props.filtersList && this.props.filtersList.length >0?
          <div className="row toolbar-pf-results">
            <Helpable bind="filters" guideRef="filters.guide">
              <div id="filters" className="col-sm-12">

                <h5>{formatMessage({id:'filters'})}: </h5>
                <ul className="list-inline">
                  {selectList}
                  <li>
                    <a style={{cursor:'pointer'}} onClick={this.props.resetFiltersHandler}>{formatMessage({id:'clearFilters'})}</a>
                  </li>
                </ul>


              </div>
            </Helpable>
          </div>

          :null)}

      </div>

    </div>


    )
  }

}

export default injectIntl(Toolbar);



// WEBPACK FOOTER //
// ./src/components/ChartPanel/Toolbar.js